import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
 
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Rewardnomination = ()=>{
    const [rewardnomination, setRewardnomination] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`rewardnomination?page=${page}`);
            setRewardnomination(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`rewardnomination/${id}`);
            setRewardnomination(rewardnomination.filter((rewardnomination) => rewardnomination.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Reward Nomination'}>
           
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Msisdn </th>
                                    <th className="px-4 py-3">Valid from </th>
                                    <th className="px-4 py-3">Valid until </th>
                                    <th className="px-4 py-3">Nominated </th>
                                    <th className="px-4 py-3">Amount </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {rewardnomination.map((rewardnomination)=>{
                                         return(
                                             <tr key={rewardnomination.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{rewardnomination.id}</td>
                                                 <td className="px-4 py-3 text-sm">{rewardnomination.msisdn}</td>
                                                 <td className="px-4 py-3 text-sm">{rewardnomination.valid_from}</td>
                                                 <td className="px-4 py-3 text-sm">{rewardnomination.valid_until}</td>
                                                 <td className="px-4 py-3 text-sm">{rewardnomination.nominated}</td>
                                                 <td className="px-4 py-3 text-sm">{rewardnomination.amount}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link to={`/reward/${rewardnomination.id}/edit`}>Award</Link> <Link className="btn btn-sm btn-outline-secondary px-5" to={`/rewardnomination/${rewardnomination.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(rewardnomination.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Rewardnomination;